/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailsTabs_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespAboutModule_user" | "PdpRespDealerDetails_user">;
    readonly " $refType": "PdpRespDetailsTabs_user";
};
export type PdpRespDetailsTabs_user$data = PdpRespDetailsTabs_user;
export type PdpRespDetailsTabs_user$key = {
    readonly " $data"?: PdpRespDetailsTabs_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetailsTabs_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailsTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '3e9e199300fce4013d1fd2aa7513e5df';
export default node;
